import React, { useState } from 'react';
import './FaqPage.css';
import Layout from '../../components/layout/Layout';

const FaqPage = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleQuestion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqs = [
    {
      category: 'Geral',
      questions: [
        {
          question: 'O que é o Plantão Fácil?',
          answer:
            'O Plantão Fácil é uma plataforma completa de gestão para médicos, desenhada para simplificar o gerenciamento de plantões, atendimentos e recebíveis. Com uma interface intuitiva e funcionalidades robustas, ela ajuda os profissionais de saúde a organizarem suas atividades diárias de forma eficiente, proporcionando maior controle e otimização do tempo.',
        },
        {
          question: 'Como posso criar uma conta?',
          answer:
            "Para criar uma conta no Plantão Fácil, acesse a página inicial e clique no botão 'Criar Conta Grátis'. Preencha o formulário com suas informações pessoais, incluindo nome, email e CPF. Após o cadastro, você receberá um email de confirmação para ativar sua conta e começar a utilizar a plataforma.",
        },
        {
          question: 'Quais são os planos disponíveis e seus benefícios?',
          answer:
            'O Plantão Fácil oferece três tipos de planos: Gratuito, Premium e Empresarial. \n\n1. **Gratuito:** Inclui funcionalidades básicas como gestão de plantões e controle de atendimentos. \n2. **Premium:** Além das funcionalidades básicas, inclui relatórios avançados, integração com sistemas de faturamento, e acesso a um suporte mais completo. \n3. **Empresarial:** Inclui todas as funcionalidades dos planos anteriores, além de suporte prioritário, customizações específicas para grandes clínicas e a possibilidade de integrar múltiplos usuários sob a mesma conta.',
        },
      ],
    },
    {
      category: 'Funcionalidades',
      questions: [
        {
          question: 'Como gerenciar meus plantões?',
          answer:
            "Para gerenciar seus plantões, acesse a seção 'Gestão de Plantões'. Aqui, você encontrará uma agenda interativa onde pode adicionar, editar e remover plantões. Basta clicar na data desejada e inserir os detalhes do plantão. O sistema permite a configuração de lembretes automáticos, que podem ser enviados via email ou SMS para garantir que você nunca perca um compromisso.",
        },
        {
          question: 'Como posso controlar os atendimentos realizados?',
          answer:
            "O controle de atendimentos pode ser feito na seção 'Controle de Atendimentos'. Nessa área, você pode registrar novos atendimentos, incluindo informações detalhadas sobre o paciente e o tratamento. Utilize o editor de texto para adicionar anamnese e observações importantes, que serão salvas no histórico do paciente para consultas futuras.",
        },
        {
          question: 'Posso registrar observações e anamnese dos pacientes?',
          answer:
            'Sim, o Plantão Fácil permite que você registre e edite anotações e anamneses detalhadas diretamente no perfil do paciente. Durante o atendimento, você pode abrir o editor de texto avançado, formatar suas anotações conforme necessário e salvar essas informações no sistema. As observações ficam acessíveis para futuras consultas e são sincronizadas em tempo real.',
        },
        {
          question: 'Como monitorar os recebíveis dos planos de saúde?',
          answer:
            "Na seção 'Recebíveis Integrados', você pode acompanhar de perto os valores a receber de cada plano de saúde. O sistema gera relatórios automáticos que detalham os valores pendentes, os pagamentos já realizados e as previsões de recebimento. Esses relatórios são exportáveis para PDF e Excel, facilitando o acompanhamento financeiro.",
        },
        {
          question: 'Quais relatórios estão disponíveis no sistema?',
          answer:
            'O Plantão Fácil oferece uma variedade de relatórios que incluem: \n\n- **Relatório de Plantões:** Detalha todos os plantões agendados e realizados, permitindo uma visão clara da sua carga de trabalho.\n- **Relatório de Atendimentos:** Mostra todos os atendimentos realizados, com filtros por data, paciente, e tipo de consulta.\n- **Relatório de Recebíveis:** Resume os valores a receber de cada plano de saúde, incluindo previsões de recebimento e histórico de pagamentos.',
        },
        {
          question: 'Como posso acessar mais funcionalidades?',
          answer:
            "Para acessar funcionalidades adicionais, você pode atualizar seu plano para Premium ou Empresarial na seção 'Assinatura'. Após a atualização, as novas funcionalidades serão automaticamente desbloqueadas, permitindo que você aproveite ao máximo tudo o que o Plantão Fácil tem a oferecer.",
        },
        {
          question:
            'Como utilizar a funcionalidade de geração de receitas médicas?',
          answer:
            'Para gerar receitas médicas no Plantão Fácil, acesse a seção "Gestão de Plantões" e selecione um atendimento. Durante o atendimento, você poderá acessar o editor de receitas e inserir todas as informações necessárias, como nome do paciente, medicamentos prescritos, e posologia. Após preencher os campos, clique em "Gerar Receita". O sistema permite a exportação da receita em formato PDF, que pode ser impressa ou enviada digitalmente para o paciente.',
        },
        {
          question: 'Como acessar a função de exportação de relatórios em PDF?',
          answer:
            'Para exportar relatórios em PDF, vá até a seção "Relatórios" e selecione o tipo de relatório desejado. Clique em "Exportar" e escolha o formato PDF. Você pode personalizar os dados que deseja incluir antes de gerar o arquivo. Esta funcionalidade é útil para armazenar registros ou compartilhá-los com terceiros de forma organizada e profissional.',
        },
      ],
    },
    {
      category: 'Suporte',
      questions: [
        {
          question: 'Como posso entrar em contato com o suporte?',
          answer:
            'Para contatar o suporte, você pode usar o formulário de contato disponível na página de ajuda, enviar um email para suporte@plantaofacil.com.br, ou usar o chat integrado na plataforma. Usuários dos planos Premium e Empresarial têm acesso a suporte prioritário, garantindo respostas rápidas e eficientes.',
        },
        {
          question: 'Onde encontro mais informações sobre o uso da plataforma?',
          answer:
            'Além desta página de FAQ, você pode acessar a central de ajuda do Plantão Fácil. Nela, você encontrará tutoriais passo a passo, vídeos explicativos, e documentação técnica que cobre todas as funcionalidades da plataforma. Esses recursos foram criados para garantir que você possa utilizar todas as ferramentas disponíveis com facilidade.',
        },
        {
          question: 'Como posso cancelar minha assinatura?',
          answer:
            "Para cancelar sua assinatura, acesse a seção 'Assinatura' no seu perfil de usuário e clique em 'Cancelar Assinatura'. Você continuará a ter acesso ao plano atual até o final do ciclo de faturamento. Após o cancelamento, sua conta será revertida para o plano gratuito, com acesso limitado às funcionalidades.",
        },
        {
          question: 'Posso mudar de plano a qualquer momento?',
          answer:
            "Sim, você pode mudar de plano a qualquer momento. Basta acessar a seção 'Assinatura', escolher o novo plano e confirmar a alteração. As funcionalidades adicionais serão liberadas imediatamente após a confirmação, permitindo que você aproveite os novos recursos sem interrupções.",
        },
      ],
    },
    {
      category: 'Utilizando o Sistema',
      questions: [
        {
          question: 'Como configurar minha agenda de plantões?',
          answer:
            "Para configurar sua agenda de plantões, acesse a seção 'Gestão de Plantões' e clique em 'Adicionar Plantão'. Escolha a data, horário e adicione detalhes específicos, como local e especialidade. Você também pode configurar lembretes que serão enviados por email ou SMS, garantindo que você seja notificado com antecedência sobre seus compromissos.",
        },
        {
          question: 'Como adicionar um novo paciente?',
          answer:
            "Na seção 'Controle de Pacientes', clique em 'Adicionar Paciente'. Preencha as informações básicas, como nome, CPF, telefone, e plano de saúde. Você pode também adicionar observações e anamnese que ficarão registradas no perfil do paciente. O sistema permite que você gerencie esses dados de forma segura e acessível.",
        },
        {
          question: 'Como gerenciar as observações dos pacientes?',
          answer:
            "Para gerenciar as observações dos pacientes, acesse o perfil do paciente na seção 'Controle de Pacientes' e clique em 'Editar Anamnese'. Um editor de texto será aberto, permitindo que você faça anotações detalhadas sobre o paciente. Essas observações são salvas automaticamente e podem ser acessadas e editadas a qualquer momento.",
        },
        {
          question: 'Como exportar os dados dos meus plantões?',
          answer:
            "Para exportar os dados dos seus plantões, vá até a seção 'Relatórios', selecione o tipo de relatório desejado e clique em 'Exportar'. Você pode escolher entre formatos como PDF ou Excel, e personalizar os dados que deseja incluir no relatório. Isso facilita a análise dos dados e a preparação de apresentações.",
        },
        {
          question: 'Como posso acessar o sistema em dispositivos móveis?',
          answer:
            'O Plantão Fácil é totalmente responsivo, permitindo que você acesse todas as funcionalidades em dispositivos móveis como smartphones e tablets. Basta acessar o site pelo navegador do seu dispositivo, e o layout se ajustará automaticamente para proporcionar a melhor experiência de uso.',
        },
        {
          question: 'Como faço para ativar as notificações de lembrete?',
          answer:
            "Para ativar as notificações de lembrete, vá até a seção 'Configurações' no seu perfil de usuário. Você pode escolher receber notificações por email, SMS, ou diretamente no aplicativo. Essas notificações ajudam a garantir que você não perca nenhum compromisso ou plantão.",
        },
      ],
    },
  ];

  return (
    <Layout>
      <div className="faq-page-container">
        <h2 className="faq-page-title">Dúvidas Frequentes</h2>
        {faqs.map((section, sectionIndex) => (
          <div key={sectionIndex} className="faq-section">
            <h2 className="faq-section-title">{section.category}</h2>
            {section.questions.map((faq, index) => (
              <div key={index} className="faq-question-item">
                <div
                  className="faq-question"
                  onClick={() => toggleQuestion(index)}
                  role="button"
                  aria-expanded={activeIndex === index}
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      toggleQuestion(index);
                    }
                  }}
                >
                  <h3>{faq.question}</h3>
                  <span>{activeIndex === index ? '-' : '+'}</span>
                </div>
                {activeIndex === index && (
                  <div className="faq-answer">
                    <p>{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        ))}
      </div>
    </Layout>
  );
};

export default FaqPage;
